import { render, staticRenderFns } from "./RoomCard.vue?vue&type=template&id=5eb85590&scoped=true&"
import script from "./RoomCard.vue?vue&type=script&lang=js&"
export * from "./RoomCard.vue?vue&type=script&lang=js&"
import style0 from "./RoomCard.vue?vue&type=style&index=0&id=5eb85590&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb85590",
  null
  
)

export default component.exports